<template>
  <span
    class="bp-spinner inline-flex items-center justify-center flex-none text-current"
    :class="[sizeClass, colorClass]"
    role="status"
    :aria-label="label"
  >
    <svg class="bp-spinner__svg w-full h-full" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke-width="2" stroke-linecap="round">
      <circle class="bp-spinner__track stroke-current opacity-20" cx="12" cy="12" r="10" />
      <circle class="bp-spinner__arc stroke-current" stroke-dasharray="16 47" cx="12" cy="12" r="10" />
    </svg>
  </span>
</template>

<script>
import { defineComponent, computed } from 'vue';

const SIZES = ['xs', 'sm', 'md', 'lg'];

const NAMED_COLORS = ['primary', 'success', 'warning', 'danger', 'dark'];

const SIZE_MAP = {
  xs: 'w-bp-3 h-bp-3',
  sm: 'w-bp-4 h-bp-4',
  md: 'w-bp-6 h-bp-6',
  lg: 'w-bp-8 h-bp-8'
};

const COLOR_MAP = {
  primary: 'text-bp-primary',
  success: 'text-bp-success',
  warning: 'text-bp-warning',
  danger: 'text-bp-danger',
  dark: 'text-bp-dark'
};

export default defineComponent({
  name: 'BpSpinner',

  props: {
    /** `xs|sm|md|lg` → 12 / 16 / 24 / 32 px. */
    size: { type: String, default: 'md' },
    color: { type: String, default: '' },
    label: { type: String, default: 'Carregando' },
  },

  setup(props) {
    const sizeClass = computed(() =>
      SIZE_MAP[SIZES.includes(props.size) ? props.size : 'md']
    );

    const colorClass = computed(() =>
      NAMED_COLORS.includes(props.color) ? COLOR_MAP[props.color] : ''
    );

    return { sizeClass, colorClass };
  },
});
</script>

<style scoped>
.bp-spinner__svg {
  animation: bp-spinner-rotate 700ms linear infinite;
}

@keyframes bp-spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .bp-spinner__svg {
    animation: none;
  }
}
</style>
